<div class="d-flex flex-wrap justify-content-end align-items-center" style="gap: 15px" [ngClass]="ngClass">
  <ng-content></ng-content>
</div>
